import React, { useState } from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import AdministrationHistoryModal from './AdministrationHistoryModal';

const AdministrationHistoryButton = ({
    patientId,
    patientName,
    size = 'default',
    type = 'default',
    style = {},
    disabled = false
}) => {
    const [historyVisible, setHistoryVisible] = useState(false);

    const handleShowHistory = () => {
        if (!patientId) {
            console.warn('No patient ID provided for administration history');
            return;
        }
        setHistoryVisible(true);
    };

    return (
        <>
            <Button
                type={type}
                size={size}
                icon={<HistoryOutlined />}
                onClick={handleShowHistory}
                disabled={disabled || !patientId}
                style={style}
            >
                Administration History
            </Button>

            <AdministrationHistoryModal
                visible={historyVisible}
                onClose={() => setHistoryVisible(false)}
                patientId={patientId}
                patientName={patientName}
            />
        </>
    );
};

export default AdministrationHistoryButton;